/**
 * 自动生成， 请不要手工修改！
 */

import { AbstractMessageResponse } from "./AbstractMessageResponse";
import { JsonTypeTagType } from "../../../serialize/JsonTypeTagType";
import { TypeFactory } from "../../../serialize/TypeFactory";

export abstract class AbstractSimpleEntityMessageResponse extends AbstractMessageResponse {
  constructor() {
    super();
  }

  abstract isAccepted(): boolean;

  public fillFromJson(json: Object, factory?: TypeFactory) {
    if (factory) {
      super.fillFromJson(json, factory);
    } else {
      super.fillFromJson(json);
    }
  }

  public fillToJson(json: Object, includeTypeTag = true) {
    super.fillToJson(json, includeTypeTag);

    if (includeTypeTag) {
      json["__type"] = "SimpleEntityMessageResponse";
    }
  }

  public getTypeId(): string {
    return "SimpleEntityMessageResponse";
  }

  public getClassName(): string {
    return "com.gong_wei.common.message.entity.api.SimpleEntityMessageResponse";
  }
}
